module.exports = __webpack_public_path__ + "8b0d01542b9ea4d822c85624857baf07.woff";